(() => {
  if (window.__ccQuickAddInit) return;
  window.__ccQuickAddInit = true;
  const config = document.querySelector('[data-cc-qa-config]');
  if (!config) return;
  const labels = JSON.parse(config.textContent);
  const rootUrl = () => window.Shopify?.routes?.root || '/';
  const state = { modal: null, data: null, chosen: [], variant: null, opener: null, busy: false, scrollLocked: false, retryable: false };
  let pending = false;
  let feedbackTimer = null;
  let retryAction = null;
  const feedback = document.createElement('aside');
  feedback.className = 'cc-qa-feedback';
  feedback.hidden = true;
  feedback.setAttribute('aria-label', labels.cartStatus);
  const message = document.createElement('p');
  message.setAttribute('role', 'status');
  message.setAttribute('aria-live', 'polite');
  message.setAttribute('aria-atomic', 'true');
  const cartLink = document.createElement('a');
  cartLink.href = labels.cartUrl;
  cartLink.textContent = labels.viewCart;
  const retry = document.createElement('button');
  retry.type = 'button';
  retry.textContent = labels.retry;
  retry.hidden = true;
  const dismiss = document.createElement('button');
  dismiss.type = 'button';
  dismiss.textContent = labels.close;
  feedback.append(message, cartLink, retry, dismiss);
  document.body.append(feedback);
  dismiss.addEventListener('click', () => { clearTimeout(feedbackTimer); feedback.hidden = true; retryAction = null; });
  retry.addEventListener('click', () => { if (!pending && retryAction) retryAction(); });

  function showFeedback(text, action, autoHide = false) {
    clearTimeout(feedbackTimer);
    feedback.hidden = false;
    message.textContent = text;
    retryAction = action || null;
    retry.hidden = !action;
    retry.disabled = pending;
    if (autoHide) feedbackTimer = setTimeout(() => { feedback.hidden = true; }, 1500);
  }

  const query = name => state.modal?.querySelector(`[data-cc-qa-${name}]`);
  const isOpen = () => state.modal && !state.modal.hidden;
  function setMessage(text) {
    const el = query('msg');
    if (el) { el.textContent = text; el.classList.toggle('is-visible', Boolean(text)); }
  }

  function optionStatus(index, value) {
    const matches = state.data.variants.filter(v => v.options[index] === value &&
      v.options.slice(0, index).every((part, i) => part === state.chosen[i]));
    return matches.some(v => v.available) ? 'available' : matches.length ? 'soldout' : 'missing';
  }

  function normalizeFollowing(index) {
    for (let i = index + 1; i < state.data.optionNames.length; i++) {
      if (optionStatus(i, state.chosen[i]) === 'available') continue;
      const next = state.data.variants.find(v => v.available &&
        v.options.slice(0, i).every((part, j) => part === state.chosen[j]));
      state.chosen[i] = next ? next.options[i] : '';
    }
  }

  function updateSelection() {
    if (!state.data) return;
    state.variant = state.data.variants.find(v => v.options.every((part, i) => part === state.chosen[i])) || null;
    query('options').querySelectorAll('[data-cc-qa-opt]').forEach(button => {
      const index = Number(button.dataset.ccQaOpt);
      const value = button.dataset.val;
      const status = optionStatus(index, value);
      const selected = state.chosen[index] === value;
      button.disabled = state.busy || status !== 'available';
      button.classList.toggle('is-on', selected);
      button.classList.toggle('is-off', status !== 'available');
      button.setAttribute('aria-pressed', String(selected));
      button.textContent = status === 'available' ? value : `${value} · ${status === 'soldout' ? labels.soldOut : labels.noCombination}`;
    });
    query('price').textContent = state.variant?.price || '';
    query('summary').textContent = `${state.chosen.filter(Boolean).join(' / ')} · ${query('qty-input').value}${labels.quantityUnit}`;
    const add = query('add');
    add.disabled = state.busy || !state.variant?.available;
    add.textContent = state.busy ? labels.adding : state.variant?.available ? state.retryable ? labels.retry : labels.add : labels.soldOut;
    state.modal.setAttribute('aria-busy', String(state.busy));
    query('qty-input').disabled = state.busy;
    state.modal.querySelectorAll('[data-cc-qa-qty]').forEach(button => { button.disabled = state.busy; });
  }

  function buildOptions() {
    const container = query('options');
    container.replaceChildren();
    state.data.optionNames.forEach((name, index) => {
      const group = document.createElement('fieldset');
      group.className = 'cc-optgrp';
      const legend = document.createElement('legend');
      legend.className = 'cc-optgrp__name';
      legend.textContent = name;
      const values = document.createElement('div');
      values.className = 'cc-optvals';
      [...new Set(state.data.variants.map(v => v.options[index]))].forEach(value => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'cc-optval';
        button.dataset.ccQaOpt = String(index);
        button.dataset.val = value;
        values.append(button);
      });
      group.append(legend, values);
      container.append(group);
    });
    updateSelection();
  }

  function openModal(opener, data) {
    if (pending) { showFeedback(labels.processing); return; }
    if (!Array.isArray(data.variants) || !data.variants.length || !Array.isArray(data.optionNames)) {
      showFeedback(labels.optionsError); return;
    }
    if (isOpen()) closeModal();
    clearTimeout(feedbackTimer);
    feedback.hidden = true;
    retryAction = null;
    state.modal = opener.closest('[data-cc-qa]')?.querySelector('[data-cc-qa-modal]') || document.querySelector('[data-cc-qa-modal]');
    if (!state.modal) return;
    state.host = opener.closest('[data-cc-qa]');
    document.body.append(state.modal);
    state.data = data;
    state.opener = opener;
    state.busy = false;
    state.retryable = false;
    state.chosen = (data.variants.find(v => v.available) || data.variants[0]).options.slice();
    query('thumb').src = data.image || '';
    query('thumb').alt = data.title || '';
    query('name').textContent = data.title || '';
    query('qty-input').value = 1;
    setMessage('');
    buildOptions();
    state.modal.hidden = false;
    state.modal.classList.add('is-open');
    state.scrollLocked = !document.body.classList.contains('cc-noscroll');
    document.body.classList.add('cc-noscroll');
    state.modal.querySelector('[data-cc-qa-opt]:not([disabled]), button[data-cc-qa-close]').focus();
  }

  function closeModal() {
    if (!isOpen()) return;
    state.modal.classList.remove('is-open');
    state.modal.hidden = true;
    if (state.scrollLocked) document.body.classList.remove('cc-noscroll');
    if (state.opener?.isConnected) state.opener.focus({ preventScroll: true });
  }

  async function addToCart(id, quantity) {
    let response;
    try {
      response = await fetch(rootUrl() + 'cart/add.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id, quantity }], sections: 'mini-cart', sections_url: location.pathname })
      });
    } catch (_) { throw Object.assign(new Error(labels.networkError), { retryable: true }); }
    let data;
    try { data = await response.json(); }
    catch (_) { throw Object.assign(new Error(labels.responseError), { retryable: false }); }
    if (!response.ok) throw Object.assign(new Error(typeof data.description === 'string' ? data.description : typeof data.message === 'string' ? data.message : labels.addError), { retryable: response.status >= 500 });
    return data;
  }

  async function submit(source, id, quantity, fromModal) {
    if (pending) return;
    const opener = state.opener;
    const modalAtSubmit = state.modal;
    const host = fromModal ? state.host : source.closest('[data-cc-qa]');
    pending = true;
    retry.disabled = true;
    retryAction = null;
    retry.hidden = true;
    const oldHtml = source.innerHTML;
    source.disabled = true;
    source.setAttribute('aria-busy', 'true');
    source.classList.add('is-busy');
    if (fromModal) { state.busy = true; setMessage(''); updateSelection(); }
    else source.textContent = labels.adding;
    try {
      const data = await addToCart(id, quantity);
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { openMiniCart: false, scrollToTop: false, sections: data.sections || null, flyFrom: fromModal ? query('thumb') : source } }));
      if (fromModal && state.modal === modalAtSubmit) closeModal();
      showFeedback(labels.success, null, true);
      if (host?.dataset.afterAdd === 'reload') location.reload();
    } catch (error) {
      const text = error.message || labels.addError;
      if (fromModal && isOpen() && state.modal === modalAtSubmit) {
        state.retryable = Boolean(error.retryable);
        setMessage(text);
      } else showFeedback(text, error.retryable ? () => {
        if (fromModal && isOpen() && state.modal === modalAtSubmit) {
          submit(query('add'), state.variant.id, Number(query('qty-input').value), true);
        } else if (fromModal && opener?.isConnected) {
          openModal(opener, state.data);
        } else if (source.isConnected) submit(source, id, quantity, false);
      } : null);
    } finally {
      pending = false;
      retry.disabled = false;
      source.removeAttribute('aria-busy');
      source.classList.remove('is-busy');
      if (fromModal) { state.busy = false; updateSelection(); }
      else { source.innerHTML = oldHtml; source.disabled = false; }
    }
  }

  document.addEventListener('click', event => {
    const target = event.target.closest?.('button, [data-cc-qa-close]');
    if (!target) return;
    const opener = target.closest('[data-cc-qa] [data-cc-options]');
    if (opener) {
      event.preventDefault();
      const json = opener.closest('[data-cc-card]')?.querySelector('[data-cc-variants]');
      try { if (!json) throw new Error(); openModal(opener, JSON.parse(json.textContent)); }
      catch (_) { showFeedback(labels.optionsError); }
      return;
    }
    const single = target.closest('[data-cc-qa] [data-cc-add]');
    if (single) {
      event.preventDefault();
      const id = Number(single.dataset.variantId);
      if (Number.isSafeInteger(id) && id > 0) submit(single, id, 1, false);
      return;
    }
    if (!isOpen() || !state.modal.contains(target)) return;
    if (target.hasAttribute('data-cc-qa-close')) { closeModal(); return; }
    if (state.busy || target.disabled) return;
    if (target.hasAttribute('data-cc-qa-opt')) {
      const index = Number(target.dataset.ccQaOpt);
      state.chosen[index] = target.dataset.val;
      normalizeFollowing(index);
      state.retryable = false;
      setMessage('');
      updateSelection();
    } else if (target.hasAttribute('data-cc-qa-qty')) {
      const input = query('qty-input');
      input.value = Math.max(1, (Number(input.value) || 1) + Number(target.dataset.ccQaQty));
      state.retryable = false;
      setMessage('');
      updateSelection();
    } else if (target.hasAttribute('data-cc-qa-add') && state.variant?.available) {
      const input = query('qty-input');
      if (!input.reportValidity()) { input.focus(); return; }
      submit(target, state.variant.id, Number(input.value), true);
    }
  });
  document.addEventListener('input', event => {
    if (event.target === query('qty-input')) { state.retryable = false; setMessage(''); updateSelection(); }
  });
  document.addEventListener('keydown', event => {
    if (!isOpen()) return;
    if (event.key === 'Escape') { event.preventDefault(); closeModal(); return; }
    if (event.key !== 'Tab') return;
    const focusable = [...state.modal.querySelectorAll('button:not([disabled]), input:not([disabled]), a[href]')].filter(el => !el.closest('[hidden]'));
    const first = focusable[0], last = focusable[focusable.length - 1];
    if (!first) return;
    if (!state.modal.contains(document.activeElement)) { event.preventDefault(); first.focus(); }
    else if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  });
})();
